import { atom } from "recoil";

export const selectedModule = atom({
  key: "selectedModule",
  default: "",
});

export const selectedReports = atom({
  key: "selectedReports",
  default: "",
});
export const selectedReportIndex = atom({
  key: "selectedReportIndex",
  default: 0,
});
